import React, { useState } from "react";
import BlogEditor from "./BlogEditor";

const BlogForm = ({
    initialData,
    onSubmit
}) => {

    const [data, setData] = useState(initialData);

    const handleSave = (status) => {
        onSubmit({
            ...data,
            status
        });
    };

    return (
        <div className="card">
            <div className="card-body">

                <div className="mb-3">
                    <label>Title</label>
                    <input
                        className="form-control"
                        value={data.title}
                        onChange={(e) =>
                            setData({
                                ...data,
                                title: e.target.value
                            })
                        }
                    />
                </div>

                <div className="mb-3">
                    <label>Author</label>
                    <input
                        className="form-control"
                        value={data.author}
                        onChange={(e) =>
                            setData({
                                ...data,
                                author: e.target.value
                            })
                        }
                    />
                </div>

                <div className="mb-3">
                    <label>Description</label>

                    <BlogEditor
                        content={data.description}
                        setContent={(value) =>
                            setData({
                                ...data,
                                description: value
                            })
                        }
                    />
                </div>

                <div className="mb-3">
                    <label>Content</label>

                    <BlogEditor
                        content={data.content}
                        setContent={(value) =>
                            setData({
                                ...data,
                                content: value
                            })
                        }
                    />
                </div>

                <div className="mb-3">
                    <label>Image</label>

                    <input
                        type="file"
                        className="form-control"
                        onChange={(e) =>
                            setData({
                                ...data,
                                image: e.target.files[0]
                            })
                        }
                    />
                </div>

                <div className="d-flex gap-2">

                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() =>
                            handleSave("draft")
                        }
                    >
                        Save Draft
                    </button>

                    <button
                        type="button"
                        className="btn btn-success"
                        onClick={() =>
                            handleSave("published")
                        }
                    >
                        Publish
                    </button>

                </div>

            </div>
        </div>
    );
};

export default BlogForm;